import type { RouteGroup } from './types';

// Import all route groups
import { commonRoutes } from './common.routes';
import { ticketRoutes } from './ticket.routes';
import { hrTicketRoutes } from './hrTicket.routes';
import { officeTicketRoutes } from './officeTicket.routes';
import { hrConfirmRoutes } from './hrConfirm.routes';
import { featureRoutes } from './feature.routes';
import { authRoutes, errorRoutes } from './auth.routes';
import { subRoutes } from './sub.routes';

// Export all individual route groups for selective use
export {
  commonRoutes,
  ticketRoutes,
  hrTicketRoutes,
  officeTicketRoutes,
  hrConfirmRoutes,
  featureRoutes,
  authRoutes,
  errorRoutes
};

// Export route types
export type { RouteType, RouteGroup } from './types';

// Combine all V2 routes
export const featRoutes: RouteGroup = [
  ...commonRoutes,
  ...ticketRoutes,
  ...hrTicketRoutes,
  ...officeTicketRoutes,
  ...hrConfirmRoutes,
  ...featureRoutes,
  ...subRoutes
];

// Combine all routes (put V2 routes first for proper root path handling)
export const allRoutes: RouteGroup = [...featRoutes, ...authRoutes, ...commonRoutes, ...errorRoutes];

// Default export for convenience
export default allRoutes;
